import React from 'react'; 
import WithConsumer from '../../context/WithConsumer';
import ProjectRow from './ProjectRow';
import ProjectMedia from './ProjectMedia';
import ProjectGallery from './ProjectGallery';
import ProjectInfo from './ProjectInfo';
import ProjectToTop from './ProjectToTop';
import { Link } from 'react-router-dom';

const Project = ({ context }) => {

	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
    
	let ctxPrevSlug = () => context.prevSlug;
	let prev = ctxPrevSlug();
    
    const ctxDoRender = () => context.doRender;
    const doRender = ctxDoRender();
       
    if (post && doRender) {
	    	    
	    let pageClass = 'c-page c-page-' + post.slug + ' c-project';
		
		if (pageLoaded) {
		    pageClass = pageClass + ' state-page-loaded';
	    }
	    
	    if (prev == '/') {
		    prev = '/design/featured/';
	    } else {
		    prev = '/design/' + prev;
	    }
	    
    	if (post.drows) {
						
			if (context.appError){
			
				return null; 
			
			} else {
				
				return (
					<>	
						<div className={pageClass}>
							
							<div className="c-page__inner c-page__inner--no-space">
							
								<div className="c-project__header c-page__block--load-effect">
																		
									<Link to={{ pathname: prev }} className="c-project__header__back" dangerouslySetInnerHTML={{__html:'<svg width="28" height="6" viewBox="0 0 28 6"><path d="M0 3L5 5.88675V0.113249L0 3ZM28 2.5L4.5 2.5V3.5L28 3.5V2.5Z" /></svg>Back to projects'}}></Link>
								
									<h1 className="c-project__header__heading" dangerouslySetInnerHTML={{__html: post.title}}></h1>		
																	
								</div>
								
								{post.drows.length > 0 &&
																			
									<ProjectRow row={post.drows[0]} first={true} twidth={post.twidth} theight={post.theight} key={0}></ProjectRow>
																		
								}
								
								{post.mrows.length > 0 &&
																			
									<ProjectMedia row={post.mrows[0]} first={true} key={0}></ProjectMedia>
																		
								}
								
								<ProjectGallery gallery={post.gllry} heading={post.title} prev={prev}></ProjectGallery>
								<ProjectInfo block={post}></ProjectInfo>
								
								{post.drows.map((row,i) =>
									{
										if (i === 0) {
											return null;
										} else {
											return (
												<ProjectRow row={row} first={false} twidth={post.twidth} theight={post.theight} key={i}></ProjectRow>
											)
										}
									}
								)}
								
								{post.mrows.map((row,i) =>
									{
										if (i === 0) {
											return null;
										} else {
											return (
												<ProjectMedia row={row} first={false} key={i}></ProjectMedia>
											)
										}
									}
								)}
								
								<ProjectToTop></ProjectToTop>
								
							</div>
							
						</div>
						
					</>
				)
					
			}
		} else {
			return null;
		}
	} else {
		return null;
	}
};
export default WithConsumer(Project);